// src/pages/SettingsPage.tsx
import React, { useState } from 'react';
import { usersApi } from '../api';
import { useAuth } from '../context/AuthContext';

export default function SettingsPage() {
  const { user, refreshUser } = useAuth();
  const [name, setName]     = useState(user?.name || '');
  const [timezone, setTz]   = useState(user?.timezone || 'Asia/Jakarta');
  const [curPwd, setCurPwd] = useState('');
  const [newPwd, setNewPwd] = useState('');
  const [saving, setSaving] = useState(false);
  const [msg, setMsg]       = useState('');

  const save = async (e: React.FormEvent) => {
    e.preventDefault(); setSaving(true); setMsg('');
    const updates: any = {};
    if (name !== user?.name) updates.name = name;
    if (timezone !== user?.timezone) updates.timezone = timezone;
    if (newPwd) {
      updates.currentPassword = curPwd;
      updates.newPassword     = newPwd;
    }

    try {
      await usersApi.updateMe(updates);
      await refreshUser();
      setMsg('Settings saved.');
      setCurPwd(''); setNewPwd('');
    } catch (err: any) { setMsg(err.response?.data?.error || 'Failed'); }
    setSaving(false);
  };

  return (
    <div style={{ maxWidth:480 }}>
      <div style={{ fontSize:26, fontWeight:600, letterSpacing:-0.5, marginBottom:24 }}>Settings</div>

      <form onSubmit={save}>
        <Section label="Profile">
          <Field label="Display name">
            <input value={name} onChange={e => setName(e.target.value)} style={inp} />
          </Field>
          <Field label="Username">
            <input value={user?.username || ''} disabled style={{ ...inp, opacity:0.5 }} />
          </Field>
          <Field label="Email">
            <input value={user?.email || ''} disabled style={{ ...inp, opacity:0.5 }} />
          </Field>
          <Field label="Timezone">
            <select value={timezone} onChange={e => setTz(e.target.value)} style={inp}>
              <option value="Asia/Jakarta">Asia/Jakarta (WIB, UTC+7)</option>
              <option value="Asia/Makassar">Asia/Makassar (WITA, UTC+8)</option>
              <option value="Asia/Jayapura">Asia/Jayapura (WIT, UTC+9)</option>
              <option value="Asia/Singapore">Asia/Singapore (SGT, UTC+8)</option>
              <option value="UTC">UTC</option>
            </select>
          </Field>
        </Section>

        <Section label="Change password">
          <Field label="Current password">
            <input type="password" value={curPwd} onChange={e => setCurPwd(e.target.value)}
              placeholder="Leave blank to keep current" style={inp} />
          </Field>
          <Field label="New password">
            <input type="password" value={newPwd} onChange={e => setNewPwd(e.target.value)}
              placeholder="12+ characters" style={inp} />
          </Field>
          <div style={{ fontSize:10, color:'var(--text3)', marginTop:4 }}>
            Must include uppercase, lowercase, number, and special character.
          </div>
        </Section>

        {msg && (
          <div style={{ fontSize:11, color: msg.includes('saved') ? 'var(--green)' : 'var(--red)', margin:'12px 0' }}>
            {msg}
          </div>
        )}

        <button type="submit" disabled={saving} style={{
          padding:'10px 24px', borderRadius:'var(--radius-sm)', fontSize:13,
          background:'var(--green)', border:'none', color:'#0c0e14', fontWeight:600, cursor:'pointer',
        }}>
          {saving ? 'Saving...' : 'Save changes'}
        </button>
      </form>
    </div>
  );
}

function Section({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div style={{ marginBottom:28 }}>
      <div style={{ fontSize:10, fontWeight:700, color:'var(--text3)', letterSpacing:'1px',
        textTransform:'uppercase', fontFamily:'var(--font-mono)', marginBottom:14 }}>
        {label}
      </div>
      {children}
    </div>
  );
}

function Field({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div style={{ marginBottom:12 }}>
      <label style={{ display:'block', fontSize:11, color:'var(--text3)', marginBottom:5,
        fontFamily:'var(--font-mono)' }}>
        {label}
      </label>
      {children}
    </div>
  );
}

const inp: React.CSSProperties = {
  width:'100%', padding:'9px 12px', background:'var(--bg3)',
  border:'1px solid var(--border2)', borderRadius:'var(--radius-sm)',
  color:'var(--text)', fontSize:12, outline:'none',
};
